import { overallFAQs, borrowerFAQs, investorFAQs } from '@/utils/FAQ';
import { TogglePill } from '../ui/TogglePill';
import FAQDropdown from './FAQDropdown';

type FAQView = 'borrower' | 'investor' | 'overall';

type FAQSectionProps = {
  activeView: FAQView;
  onViewChange: (view: FAQView) => void;
  onToggleFAQ?: (question: string, open: boolean) => void;
};

export default function FAQSection({ activeView, onViewChange, onToggleFAQ }: FAQSectionProps) {
  const faqsByView = {
    borrower: borrowerFAQs,
    investor: investorFAQs,
    overall: overallFAQs,
  } as const;

  const faqs = faqsByView[activeView];

  return (
    <div className="w-full py-8 lg:py-16 px-6 lg:px-14 rounded-3xl lg:rounded-[40px] border border-gray-200 flex flex-col justify-start items-center gap-6 bg-gradient-to-l from-[#CFD9FF]/15 to-[#FFF0DE]/15 max-w-[1510px] mx-auto">
      {/* Tab Switcher */}
      <div className="px-2 sm:px-2.5 py-2 bg-white rounded-3xl flex justify-start items-start gap-2 scale-75 sm:scale-90 lg:scale-100">
        <TogglePill
          label="Overall"
          isActive={activeView === 'overall'}
          onClick={() => onViewChange('overall')}
          size="large"
          variant="inverted"
        />
        <TogglePill
          label="Borrower"
          isActive={activeView === 'borrower'}
          onClick={() => onViewChange('borrower')}
          size="large"
          variant="inverted"
        />
        <TogglePill
          label="Investor"
          isActive={activeView === 'investor'}
          onClick={() => onViewChange('investor')}
          size="large"
          variant="inverted"
        />
      </div>

      {/* FAQ List */}
      <div className="w-full flex flex-col items-center max-w-[1090px]">
        <div className="w-full flex flex-col gap-3">
          {faqs.map((fq) => (
            <FAQDropdown
              key={fq.question}
              question={fq.question}
              answer={fq.answer}
              onToggle={(open) => onToggleFAQ?.(fq.question, open)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
